import React from 'react';
import { FOOTER_LINKS, SUPPORT_EMAIL } from '../data/config';
export function Footer() {
  return <footer className="bg-navyDeep px-4 py-5 text-center md:px-12" data-id="element-73" data-mp="3gfiugihumbe4">
      <p className="font-heading text-[11px] font-extrabold uppercase text-white" data-id="element-74" data-mp="32nul2myzi10u">
        © 2026 Bright Digital Hub — All rights reserved.
      </p>
      <p className="mx-auto mt-1.5 max-w-[640px] text-[12px] leading-[1.4] text-white/70" data-id="element-75" data-mp="36q92r3qx2uqj">
        AQUA CLASS HUB™ provides educational aquatic fitness materials and professional instructional resources. It does
        not replace qualified instructor training, individualized participant assessment, appropriate aquatic
        supervision, facility safety procedures, or applicable legal and professional requirements.
      </p>
      <nav aria-label="Legal" className="mt-1.5 text-[12px] text-white" data-id="element-76" data-mp="3qfjhofiu9bnl">
        {FOOTER_LINKS.map((l, i) => <React.Fragment key={l.label} data-id="element-77" data-mp="2ey9zrxfcyroe" data-mpi={i}>
            {i > 0 && <span className="mx-1.5" aria-hidden data-id="element-78" data-mp="2ez1iw8rrqwxs">•</span>}
            <a href={l.href} className="transition-colors duration-150 hover:text-gold" data-id="element-79" data-mp="3l9adfilcf44f">
              {l.label}
            </a>
          </React.Fragment>)}
      </nav>
      <p className="mt-1 text-[12px] text-white" data-id="element-80" data-mp="3gctqgrpvqvsx">
        Customer Support:{' '}
        <a href={`mailto:${SUPPORT_EMAIL}`} className="underline hover:text-gold" data-id="element-81" data-mp="3v9193nln3p63">
          {SUPPORT_EMAIL}
        </a>
      </p>
    </footer>;
}